module.exports = __webpack_public_path__ + "static/media/PTG-1.08061881.png";